const FORATABLE_MODAL_URL = 'https://guest.foratable.com/restaurants/f125bd6e9e8a4858688319713cbf2259?embed=modal';

export const getForatableModalUrl = (language) => `${FORATABLE_MODAL_URL}&lang=${language}`;
